import { Superscript } from "@hypercard/web-components";

export const TileHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    <Superscript size="md" className="mb-3 text-white/50">
      {children}
    </Superscript>
  );
};
